import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { NotificationBadgeContext } from "../../../NotificationBadgeContext";
import { SideBarContext } from "./SideBar";
import "./SideBarItem.css";

export default function SideBarItem({ item }) {
  const { isExpanded, setIsExpanded, isMobile } = useContext(SideBarContext);
  const [notifications] = useContext(NotificationBadgeContext);
  const location = useLocation();

  const notificationCount = notifications
    ? Object.values(notifications).reduce((prev, curr) => prev + curr, 0)
    : 0;

  const isActive =
    location.pathname === item.url ||
    (item.active && item.active.some((regex) => regex.test(location.pathname)));

  const handleClick = () => {
    if (isMobile && isExpanded && setIsExpanded) {
      setIsExpanded(false);
    }
  };

  return (
    <li className="sidebar-item-container">
      <Link
        to={item.url}
        onClick={handleClick}
        className={`sidebar-item ${isActive ? "active" : ""} ${!isExpanded ? "minimized" : ""}`}
        title={!isExpanded ? item.label : undefined}
        aria-label={item.label}
      >
        <i className={item.icon} aria-hidden="true" />
        {isExpanded && <span className="mx-2">{item.label}</span>}
        {item.url === "/chat" && notificationCount > 0 && (
          <span
            className="sidebar-notification-badge border-circle text-white text-sm bg-cyan-600 px-2 py-1"
          >
            {notificationCount}
          </span>
        )}
      </Link>
    </li>
  );
}